<template>
    <div>
        <div class="clearbox"></div> 
        <img class="bannerbox"  src="../../static/images/banner2.jpg" /> 
        <div class="clearbox"></div> 
        <div class="contentlist"> 
            <div class="index-width"> 
                <div class="listbox-left"> 
                    <div class="position">
                      
                        <span>当前位置：<a ><router-link to="/">首页</router-link></a>&nbsp;&gt;&gt;&nbsp;<a ><router-link to="introduce">公司介绍</router-link></a>&nbsp;&gt;&gt;&nbsp;<a @click="gotoType('introduce')">公司简介</a></span>
                    </div> 
                    <div class="Articlebox"> 
                        <h1>公司简介</h1> 
                        <div class="a-text-c"> 
                            <div> 
                            <p> 集团自成立以来业态规模不断扩展，为绿色正能量在世界各地范围传播发挥了积极作用。分别专注于工业储能（含超级电容器）、汽车太阳能和绿色建筑的BIPV，新能源汽车及充电基础设施的研发、生产和运营以及新能源汽车的分时租赁、销售及相关增值服务，业务范围覆盖亚欧美三大目标市场<br>&nbsp;</p>
                            <p>　　在充电基础设施领域， 集团拥有三方面优势：一是海外市场运营经验成熟，在欧美多地成功建设充电站并安全运营多年，广受外国友人认可；二是能够提供定制化的充电基础设施解决方案，备有多种商业模式可选，能够有效满足不同公共场所的特殊需求；三是充电桩产品水平世界领先，自主研发的充电桩产品具有智能性强，安全性高等特点，通过最严苛的美国UL、欧盟CE、中国国标等认证，兼容性符合国际，欧美SAE Combo等快速充电标准，能够与国内外所有主流新能源汽车完成充电协议对标。<br> 　　在储能领域，集团以比肩国际巨头为目标，围绕工业电容器、超级电容和储能系统打造核心产品线，销售网络遍及全国和欧洲，产品广泛应用于新能源领域。<br> 　　在光伏领域， 集团拥有全球一流的太阳能系统、光伏建筑一体化系统和汽车太阳能组件的研发和制造技术，是全球三家汽车曲面太阳能组件制造企业之一，也是两家获得欧盟绿色认证的企业之一。<br><br>﻿<br>　　2016年， 旗下全资子公司 新能源汽车销售公司成立，利用互联网、信息化、智能化及运营服务理念，将“小易充电”，“小易租车”两大核心业务完美结合，形成了从充电基础设施研发运营到新能源汽车销售再到新能源汽车分时租赁及后期多种增值服务为一体的新能源产业链。</p>
                            <p><br></p> 
                            </div> 
                        </div> 
                    </div> 
                </div> 
                <!-- <div class="listbox-right"> 
                    <h2><span>公司介绍</span></h2> 
                    <ul> 
                    <li><a  class="active"><router-link to="introduction">公司简介</router-link></a></li> 
                    <li><a href="/about/25.html">大事记</a></li> 
                    </ul> 
                </div>  -->
                <boxRight :mainTitle="mainTitle" :liData="liData" @routerData="routerData"></boxRight>
            </div> 
        </div> 
   <div class="clearbox"></div> 
   <footerNew></footerNew>
   <!-- <div class="footerbox"> 
    <div class="index-width"> 
     <div class="fott-box2"> 
      <div class="box2-right">
       <span><a href="https://beian.miit.gov.cn" target="_blank">京ICP备2023020153号-1</a>|CopyRight© 2023  集团</span>
      </div> 
     </div> 
    </div> 
   </div>  -->
   </div>
    
  </template>
  <script>
        import boxRight from '@/component/listBoxRight.vue'
        import footerNew from '@/component/footerNew.vue'
        export default {
            components:{
                boxRight,
                footerNew					
            },
            name: 'introduction',
            data () {
                return {
                    mainTitle:"公司介绍",
                    liData:[
                        {name:"公司简介",routerTo:"introduction",isActive:true,type:'1',classification:'2-1'},
                        {name:"大事记",routerTo:"thing",type:'2',classification:'2-2'},
                    ]
                }
            },
            methods:{
                routerData(e){
                    console.log(e)
                    if(e.type){
                        this.$router.push({
                            path: e.routerTo,
                            query: {
                                type: e.type
                            }
                        })
                        this.$store.commit('newSet',e.classification)
                    }
                },
                gotoType(e){
                    this.$router.push({path: e});
                    if(e == 'thing'){
                        this.$store.commit('newSet','2-2')
                    }else if(e == 'introduction'){
                        this.$store.commit('newSet','2-1')
                    }else{
                        this.$store.commit('newSet','2-3')
                    }
                    
                }
            }
        }
  </script>
  
  <style scoped>
  ul, ol, li {
    list-style: none;
}
  .footerbox .fott-box2 {
    width: 100%;
    float: left;
    height: 50px;
}
.footerbox .fott-box2 .box2-right span {
    font-size: 14px;
    color: #181818;
    margin: 0 15px;
}
.footerbox .fott-box2 .box2-right {
    float: right;
    line-height: 50px;
    color: #e4e4e4;
    font-family: Tahoma;
}
  .contentlist .listbox-right {
    float: right;
    width: 200px;
}
.contentlist .listbox-right ul li a:hover, .contentlist .listbox-right ul li a.active {
    color: #18D1BB;
}
.contentlist .listbox-right ul li a {
    float: left;
    font-size: 14px;
    color: #000;
}
.contentlist .listbox-right ul li {
    width: 100%;
    float: left;
    line-height: 32px;
    box-sizing: border-box;
    padding-left: 15px;
    background: url(../../static/images/don.gif) no-repeat 5px center;
}
.footerbox {
    margin: 0 auto;
    width: 100%;
    overflow: hidden;
    background: url(../../static/images/bottom_bg.jpg) repeat-x left bottom;
}
.contentlist .listbox-right ul {
    width: 100%;
    float: left;
    margin: 15px 0;
    height: 128px;
}
.contentlist .listbox-right h2 span {
    line-height: 48px;
    font-size: 18px;
    color: #000;
    float: left;
    margin-left: 10px;
}
.contentlist .listbox-right h2 {
    width: 100%;
    height: 48px;
    background-color: #f8f8f8;
    padding: 0 10px;
    box-sizing: border-box;
}
  .contentlist .Articlebox {
    width: 780px;
    float: left;
    min-height: 600px;
}
div, form, ul, ol, li, span, p, dl, dt, dd, img {
    margin: 0;
    padding: 0;
    border: 0;
}
.contentlist .Articlebox .a-text-c {
    font-size: 14px;
    line-height: 28px;
    color: #333333;
    display: block;
    padding: 10px 20px;
    margin-top: 15px;
}
.contentlist .Articlebox h1 {
    display: block;
    padding: 45px 0 5px;
    text-align: center;
    font-size: 19px;
}
  a {
    color: #20366f;
    text-decoration: none;
}
  .position {
    width: 100%;
    float: left;
    border-bottom: 1px solid #dddddd;
    font-family: Tahoma;
    font-size: 14px;
    color: #666666;
    padding: 15px 0;
}
.position a, .position span {
    display: inline-block;
    font-size: 14px;
    color: #666666;
    margin: 0 5px;
}
    .contentlist .listbox-left {
        width: 760px;
        float: left;
    }
  .contentlist {
    margin: 30px auto 15px;
    overflow: hidden;
    width: 100%;
}
.index-width {
    width: 1000px;
    margin: 0 auto;
    position: relative;
}
  .bannerbox {
    margin: 0 auto;
    overflow: hidden;
    width: 100%;
    height: 208px;
    object-fit: cover;
}
  .clearbox {
    border-top: 1px solid transparent !important;
    margin-top: -1px !important;
    margin-top: 0px;
    clear: both;
    font-size: 0px;
    line-height: 0px;
    height: 0px;
    border: 0px;
    visibility: hidden;
}
    *{
      box-sizing: border-box;
      margin:0;
      padding:0;
    }
   
  </style>